import { createBrowserRouter } from 'react-router-dom'
import { NotFoundPage } from './pages/NotFoundPage'
import { AdminRoutes } from './AdminRoutes'
import { SuperUserRoutes } from './SuperUserRoutes'
import { StoreRoutes } from './StoreRoutes'
import { EmbedRoutes } from './EmbedRoutes'

export const router = createBrowserRouter([
  // Ticket is denormalized and has a HASH index of ticketId.  Only needs react-router and the U.I.
  // We separate it from everything else in the app
  { path: '/ticket/:ticketId', lazy: () => import('./pages/ticket.$ticketId') },

  { path: '/store/:oid/embed',
    lazy: () => import('./pages/_barebonesLayout'),
    children: [
      {path: 'calendar', lazy: () => import('./pages/embed.$oid.calendar')},
      {path: 'festivals/:pid/calendar', lazy: () => import('./pages/embed.$oid.festivals.$pid.calendar')},
    ]
  },
  {
    path: '/', lazy: () => import('./pages/_index'),
    children: [
      // These embeds are designed to be used in an iframe, so they do not use any
      // layouts. They are nested just deeply enough to get the needed context
      { path: '__/auth/action', lazy: () => import('./pages/__.auth.action') },
      { path: '', lazy: () => import('./pages/index') },
      { path: 'organization-privacy-policy', lazy: () => import('./pages/organization-privacy-policy') },
      { path: 'organization-tos', lazy: () => import('./pages/organization-tos') },
      { path: 'features', lazy: () => import('./pages/features') },
      { path: 'pricing', lazy: () => import('./pages/pricing') },
      { path: 'my-tickets', lazy: () => import('./pages/my-tickets') },
      { path: 'getting-started', lazy: () => import('./pages/getting-started') },
      { path: 'staff/:oid/schedule/:uid', lazy: () => import('./pages/staff.$oid.schedule.$uid') },
      {
        path: '/embed',
        lazy: () => import('./pages/_barebonesLayout'),
        children:  EmbedRoutes
      },
      {
        path: 'store',
        lazy: () => import('./pages/_store'),
        children: StoreRoutes,
      },
      {
        path: 'admin',
        children: [
          { path: '', lazy: () => import('./pages/admin') },
          { path: 'create-organization', lazy: () => import('./pages/admin.create-new-organization') },
          {
            path: 'su',
            lazy: () => import('./pages/admin._su'),
            handle: { layout: true },
            children: SuperUserRoutes
          },
          {
            path: ':oid',
            lazy: () => import('./pages/admin._$oid'),
            handle: { layout: true },
            children: AdminRoutes,
          },
        ],
      }
    ]
  },
  { path: '*', element: <NotFoundPage goBackPath='/' goBackText='Go back home' /> },
]) as any
